module.exports = __webpack_public_path__ + "static/media/7_avatar.cf29de40.png";